/**
 * Gravity Forms — place un champ conditionnel sous un choix checkbox précis.
 *
 * GF affiche toujours les champs après le bloc entier ; on déplace le DOM
 * sous le <li> du choix correspondant (données / sync inchangées).
 */

const NEST_CONFIG = [
    {
        formId: 2,
        checkboxFieldId: 21,
        nests: [
            { fieldId: 20, choiceValue: 'ecologique-sociale' },
            { fieldId: 19, choiceValue: 'mediation' },
        ],
    },
];

const NESTED_CLASS = 'hf-gf-nested-under-choice';

/**
 * @param {number|string} formId
 * @param {number|string} fieldId
 * @returns {HTMLElement|null}
 */
function getFieldEl(formId, fieldId) {
    return document.getElementById(`field_${formId}_${fieldId}`);
}

/**
 * @param {HTMLElement} checkboxField
 * @param {string} choiceValue
 * @returns {HTMLElement|null}
 */
function findChoiceItem(checkboxField, choiceValue) {
    const inputs = checkboxField.querySelectorAll('input[type="checkbox"]');

    for (const input of inputs) {
        if (input.value === choiceValue) {
            return (
                input.closest('li') ||
                input.closest('.gchoice') ||
                input.parentElement
            );
        }
    }

    return null;
}

/**
 * @param {{ formId: number, checkboxFieldId: number, nests: Array<{fieldId: number, choiceValue: string}> }} config
 */
function nestFieldsForConfig(config) {
    const checkboxField = getFieldEl(config.formId, config.checkboxFieldId);

    if (!checkboxField) {
        return;
    }

    config.nests.forEach(({ fieldId, choiceValue }) => {
        const field = getFieldEl(config.formId, fieldId);
        const choiceItem = findChoiceItem(checkboxField, choiceValue);

        if (!field || !choiceItem) {
            return;
        }

        if (field.parentElement === choiceItem) {
            field.classList.add(NESTED_CLASS);
            return;
        }

        choiceItem.appendChild(field);
        field.classList.add(NESTED_CLASS);
    });
}

function nestAllConfiguredFields() {
    NEST_CONFIG.forEach(nestFieldsForConfig);
}

/**
 * Initialise le nesting (rejoué après render / logique conditionnelle GF).
 */
export function initGfNestConditionalFields() {
    if (document.body.dataset.hfGfNestFields === '1') {
        return;
    }

    document.body.dataset.hfGfNestFields = '1';

    nestAllConfiguredFields();

    document.addEventListener('gform_post_render', nestAllConfiguredFields);

    // Après coche / décoche : la logique conditionnelle GF vient de basculer.
    document.addEventListener(
        'change',
        (event) => {
            const target = event.target;
            if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') {
                return;
            }

            const isConfiguredCheckbox = NEST_CONFIG.some((config) => {
                const checkboxField = getFieldEl(config.formId, config.checkboxFieldId);
                return checkboxField && checkboxField.contains(target);
            });

            if (!isConfiguredCheckbox) {
                return;
            }

            window.requestAnimationFrame(nestAllConfiguredFields);
            window.setTimeout(nestAllConfiguredFields, 50);
        },
        true
    );

    if (window.jQuery) {
        window.jQuery(document).on(
            'gform_post_render gform_post_conditional_logic',
            nestAllConfiguredFields
        );
    }
}
